export default {
  name: 'image-text-component',
  props: [ 'mode' ]
}



// WEBPACK FOOTER //
// ./src/components/image-text/script.js